<template>
  <div class="parentWrapper">
    <div
      v-if="firstLoading || allPlan == null || customerPlan == null"
      class="emptyWrapper"
    >
      <v-progress-circular
        :size="40"
        :width="3"
        color="#787ff7"
        indeterminate
      ></v-progress-circular>
    </div>

    <div v-else class="wrapper d-flex flex-column">
      <div v-if="user !== null" class="userInfo">
        <div class="userHeadWrapper">
          <div class="userInfoTitle">
            {{ $t("start.hello") }}
            {{ user.Name === "" ? user.Email : user.Name }}
          </div>
        </div>
        <div class="usageInfo">
          <strong>{{ $t("start.paymentInformation") }}</strong>
          <!-- <a class="charge" href="plan"
            >эрх сунгах <ForwardArrowIcon class="forwardArrowIcon"
          /></a> -->
          <div class="usagePanel" v-if="customerBalance != null">
            <!-- <div class="usageCard">
              <p>{{ $t("start.totalNumberPages") }}</p>
              <h2 style="display: inline">
                ~{{ Math.floor(customerBalance.TotalBalance / 3750) }}
              </h2>
              <span>{{ $t("start.page") }}</span>
            </div> -->
            <div class="usageCard">
              <p>{{ $t("start.totalNumberCharacters") }}</p>
              <h2 style="display: inline">
                ~{{
                  isTooLargeNumber(Math.floor(customerBalance.TotalBalance))
                }}
              </h2>
              <span>{{ $t("start.characters") }}</span>
            </div>
            <div class="usageCard">
              <p>{{ $t("start.leftCharactersPages") }}</p>
              <h2 style="display: inline">
                ~{{
                  isTooLargeNumber(
                    Math.floor(
                      customerBalance.TotalBalance - customerBalance.TotalUsed
                    )
                  )
                }}
              </h2>
              <span>{{ $t("start.characters") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-column">
        <div class="project">
          <div v-if="tListLoading" class="loadingWrapper">
            <v-progress-circular
              :size="40"
              :width="3"
              color="#787ff7"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="projectHeader">
            <strong>{{ $t("start.texts") }}</strong>
            <a class="seeMore" href="projects"
              >{{ $t("start.readMore") }}
              <ForwardArrowIcon class="forwardArrowIcon"
            /></a>
          </div>
          <div v-if="textGroupList.length == 0" class="emptyListWrapper">
            <v-btn
              class="redirectBtn"
              @click="() => $router.push({ name: 'projects' })"
            >
              {{ $t("start.insertNewTextButton") }}
              <ForwardArrowIcon class="forwardArrowIcon" />
            </v-btn>
          </div>
          <template v-else v-for="item in textGroupList">
            <FolderInfo
              :folderInfo="{
                name: item.name,
                time: item.id,
                created_date: item.created_date,
                audiosCount: item.item_number,
                id: item.id,
              }"
              whereToOpen="textFolderDetails"
              :updateList="getTextGroupList"
              :key="item.id"
              ><NewFolderIcon
            /></FolderInfo>
          </template>
        </div>
        <!-- <div v-if="isFileSynth" class="project">
          <div v-if="fListLoading" class="loadingWrapper">
            <v-progress-circular
              :size="40"
              :width="3"
              color="#787ff7"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="projectHeader">
            <strong>Файлууд</strong>
            <a class="seeMore" href="/books"
              >Дэлгэрэнгүй <ForwardArrowIcon class="forwardArrowIcon"
            /></a>
          </div>
          <div
            class="emptyListWrapper"
            v-if="fileGroupList.length == 0"
            @click="() => $router.push({ name: 'books' })"
          >
            <v-btn class="redirectBtn">
              Шинэ файл оруулах
              <ForwardArrowIcon class="forwardArrowIcon" />
            </v-btn>
          </div>
          <template v-else v-for="item in fileGroupList">
            <FolderInfo
              :folderInfo="{
                name: item.name,
                time: item.id,
                created_date: item.created_date,
                audiosCount: item.item_number,
                id: item.id,
              }"
              whereToOpen="fileFolderDetails"
              :updateList="getFileGroupList"
              :key="item.id"
              ><NewFolderIcon />
            </FolderInfo>
          </template>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import FolderInfo from "../components/FolderInfo";
import NewFolderIcon from "../components/icons/NewFolderIcon";
import ForwardArrowIcon from "../components/icons/ForwardArrowIcon";
import { mapState, mapActions } from "vuex";
export default {
  name: "Start",
  components: {
    FolderInfo,
    NewFolderIcon,
    ForwardArrowIcon,
  },
  data: () => ({
    dialog: false,
    projectName: null,
    textGroupList: [],
    fileGroupList: [],
    token: null,
    count: 0,
    page: 1,
    pageCount: 0,
    totalProjects: 0,
    itemsPerPage: 3,

    convertLoading: false,
    loading: true,
    tListLoading: true,
    fListLoading: true,
    firstLoading: true,
  }),
  computed: {
    ...mapState(["user", "allPlan", "customerPlan", "customerBalance"]),

    getToken: function() {
      return this.$cookie.get("token");
    },
    isFileSynth: function() {
      let plan = this.allPlan.find(
        (plan) => plan.ID === this.customerPlan.PlanID
      );
      let isFile = plan.Feature.privilege.split(",").indexOf("file");
      if (isFile != -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.showData();
  },
  watch: {
    allPlan: function() {
      this.showData();
    },
    customerPlan: function() {
      this.showData();
    },
  },
  methods: {
    ...mapActions([
      "showErrorMessage",
      "showWarningMessage",
      "showSuccessMessage",
      "checkError",
    ]),
    isTooLargeNumber(number) {
      if (number > 1000000) {
        let mNumber = number / 1000000;
        return Math.floor(mNumber) + "сая";
      } else return Math.floor(number);
    },
    getTextGroupList() {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/group?type=text&page=${this.page}&per_page=${this.itemsPerPage}`,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.data.Count != 0) {
            this.textGroupList = response.data.data.List;
            this.totalProjects = response.data.data.Count;
            this.pageCount = Math.ceil(
              response.data.data.Count / this.itemsPerPage
            );
          } else {
            this.textGroupList = [];
          }
          this.tListLoading = false;
          this.firstLoading = false;
        })
        .catch((error) => {
          this.tListLoading = false;
          this.checkError(error);
        });
    },
    getFileGroupList() {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/group?type=file&page=${this.page}&per_page=${this.itemsPerPage}`,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.data.Count != 0) {
            this.fileGroupList = response.data.data.List;
            this.totalProjects = response.data.data.Count;
            this.pageCount = Math.ceil(
              response.data.data.Count / this.itemsPerPage
            );
          } else {
            this.fileGroupList = [];
          }
          this.fListLoading = false;
          this.firstLoading = false;
        })
        .catch((error) => {
          this.fListLoading = false;
          // this.checkError(error);
          console.log(error);
        });
    },

    createGroup() {
      if (this.projectName != null) {
        const headers = {
          token: this.getToken,
        };
        this.convertLoading = true;
        axios
          .post(
            `${process.env.VUE_APP_BASE_URL}/creategroup`,
            { GroupName: this.projectName, GroupType: "text" },
            { headers }
          )
          .then((response) => {
            if (this.list == this.itemsPerPage) {
              var moveArray = this.list;
              moveArray.pop();
              this.list = [response.data.data, ...moveArray];
            } else {
              this.list = [response.data.data, ...this.list];
            }
            this.totalProjects++;
            this.pageCount = Math.ceil(
              (this.totalProjects + 1) / this.itemsPerPage
            );

            this.convertLoading = false;
            this.dialog = false;
          })
          .catch((error) => {
            this.convertLoading = false;
            this.checkError(error);
          });
        this.projectName = null;
      } else {
        this.showErrorMessage({
          message: this.$t("start.errorMsg"),
          timeout: 3000,
        });
      }
    },

    closeDialog() {
      this.dialog = false;
    },
    showData() {
      if (this.allPlan != null && this.customerPlan != null) {
        this.getTextGroupList();
        if (this.isFileSynth) {
          this.getFileGroupList();
        }
      }
    },
  },
};
</script>
<style scoped>
.loadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 541px;
  margin-bottom: 20px;
}

.parentWrapper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
  padding-bottom: 20px;
}

.wrapper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
}

.emptyWrapper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
}

.userHeadWrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.userInfoTitle,
.emptyTitle {
  font-weight: 700;
  text-align: left;
  line-height: 23px;
  font-size: 20px;
  color: #000000;
  margin-bottom: 5px;
}

.emptyTitle {
  width: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.emptyInfo {
  color: #767676;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 30px;
}

.emptyDescWrapper {
  display: flex;
  flex-direction: column;
  width: 350px;
  border-radius: 6px;
  border: 2px solid #e5e5e5;
  padding: 20px;
  margin-top: 30px;
}

.quizTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.quizStyle {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #231f20;
  margin-left: 10px;
}

.quizDesc {
  font-size: 14px;
  color: #767676;
  text-align: justify;
}

.emptyListWrapper {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  border-radius: 6px;
}

.projectsHeadRightWrapper {
  display: flex;
  flex-wrap: wrap;
  /* align-items: center;
  justify-content: center; */
  margin-bottom: 10px;
}

.position {
  text-align: right;
}

.showDialogBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 20px;
  margin-bottom: 5px;
  height: 40px !important;
  width: 155px;
}

.paginationWrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.dialogWrapper {
  padding: 31px 38px;
}

@media screen and (max-width: 768px) {
  .dialogWrapper {
    padding: 20px;
  }
}

.dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.folderIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  background-color: #eff0fd;
  border-radius: 3px;
  margin-right: 10px;
}

.dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

.dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.createInputWrapper {
  display: flex;
  position: relative;
  height: 40px;
}
.createInputWrapper input[type="text"] {
  /* height: 40px; */
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.createInputWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.createInputWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.createBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.projectHeader {
  display: flex;
  justify-content: space-between;
  margin: 14px 0px;
}

.charge {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: #98a7ad;
  font-size: 14px;
  margin-left: 14px;
}

.seeMore {
  display: flex;
  align-items: center;
  text-decoration: none;
  text-align: center;
  color: #98a7ad;
  font-size: 14px;
}

.forwardArrowIcon {
  margin-left: 10px;
}

.seeMore:hover {
  color: #0d66d0;
}
.usagePanel {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.usageCard {
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 15px;
  margin-right: 12px;
}
.usageCard > p,
span {
  color: #767676;
}
.snackBar1 {
  color: green !important;
}

.redirectBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-bottom: 10px;
  height: 40px !important;
  width: 200px;
  letter-spacing: 0;
  text-indent: 0;
}
</style>
